import { useEffect, useState } from 'react'

import PropTypes from 'prop-types'

import { parseError } from 'noauth/pages/Login/loginApi'
import LoginFormCard from 'noauth/pages/Login/LoginFormCard'
import LoginSubmitButton from 'noauth/pages/Login/LoginSubmitButton'

import { AnimatedInput } from 'core/components'
import { useWrite } from 'core/hooks'
import { useBootstrapStore } from 'core/stores'
import { ExpectedError } from 'core/system/ErrorLogging'

const BasicPasswordLogin = ({ onLogin }) => {
  const { authValueType } = useBootstrapStore()

  const authValueLabel =
    authValueType === 'email' ? 'Email'
    : authValueType === 'phone' ? 'Phone Number'
    : authValueType === 'username' ? 'Username'
    : 'Unknown Authentication Type'

  const [authValue, setAuthValue] = useState('')
  const [password, setPassword] = useState('')

  const [onSubmit, sending, resp, error, clear] = useWrite(() => {
    if (!authValue) throw new ExpectedError(`${authValueLabel} is required`)

    if (!password) throw new ExpectedError('Password is required')

    return onLogin({ username: authValue, password })
  })

  const errorMessage = parseError(error)

  useEffect(() => {
    clear()
  }, [authValue, password, clear])

  const hasEmptyInputs = !authValue || !password

  const handleEnter = () => {
    if (authValue && password && !sending) onSubmit()
  }

  const handleChange = (event) => {
    // BE should be case insensitive,
    // but also setting to lowercase for aesthetic reasons for the user
    setAuthValue(event.target.value.toLowerCase())
  }

  return (
    <LoginFormCard>
      <AnimatedInput
        disabled={sending || !!resp}
        label={authValueLabel}
        name={authValueType}
        onChange={handleChange}
        onEnter={handleEnter}
        placeholder=' '
        showError={error && !authValue}
        type='text'
        value={authValue}
      />
      <AnimatedInput
        disabled={sending || !!resp}
        hasEmptyInputs={hasEmptyInputs}
        label='Password'
        name='password'
        onChange={(e) => setPassword(e.target.value)}
        onEnter={handleEnter}
        placeholder=' '
        showError={error && !password}
        type='password'
        value={password}
      />

      <LoginSubmitButton disabled={!!resp} errorMessage={errorMessage} onSubmit={onSubmit} sending={sending} />
    </LoginFormCard>
  )
}

BasicPasswordLogin.propTypes = {
  onLogin: PropTypes.func,
}

export default BasicPasswordLogin
